import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Signature } from '@blaze-shared/schema-domain';

@Component({
  selector: 'blaze-signature-column-value',
  templateUrl: './signature-column-value.component.html',
  styleUrls: ['./signature-column-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SignatureColumnValueComponent {
  @Input()
  signature: Signature | undefined;
}
